import { setupFormState } from '@/components/form/tidal-form'
import { RoadSegmentFormValues } from './types'

export const form = setupFormState<RoadSegmentFormValues>({
  id: 'roadEditorForm',
  initialValues: {
    id: '',
    name: '',
    type: 'disabled',
    additionalDrivingTimeSec: 0,
    editableSegment: {
      start: { lat: 0, lng: 0 },
      end: { lat: 0, lng: 0 },
    },
  },
})
